import { z } from 'zod'

export const EventMatchingPauseConfigSchema = z.object({
    pause_event_matcher: z.boolean().nullish(),
    excluded_lots: z.array(z.string()).nullish()
})

export type EventMatchingPauseConfig = z.infer<typeof EventMatchingPauseConfigSchema>

export const GetEventMatchingPauseConfigQuerySchema = EventMatchingPauseConfigSchema

export type GetEventMatchingPauseConfigQuery = z.infer<typeof GetEventMatchingPauseConfigQuerySchema>

export const UpdateEventMatchingPauseConfigVariablesSchema = z.object({
    event_matching_pause_config_json: EventMatchingPauseConfigSchema
})

export type UpdateEventMatchingPauseConfigVariables = z.infer<typeof UpdateEventMatchingPauseConfigVariablesSchema>

// Backend returns the list of excluded_lots that were invalid (not found in db).
export const UpdateEventMatchingPauseConfigMutationSchema = z.array(z.string())

export type UpdateEventMatchingPauseConfigMutation = z.infer<typeof UpdateEventMatchingPauseConfigMutationSchema>
